import ObjectTypes from "Lib/constants/app/objectTypes";
import ContactTypes from "Lib/constants/contacts/contactTypes";

export const OwnerShareObjectTypes = [
	ObjectTypes.Lease,
	ObjectTypes.Property,
	ObjectTypes.Unit,
	ObjectTypes.Portfolio,
	ObjectTypes.Contact,
	ObjectTypes.WorkOrder,
	ObjectTypes.Bill
];

export const TenantShareObjectTypes = [
	ObjectTypes.Lease,
	ObjectTypes.Property,
	ObjectTypes.Unit,
	ObjectTypes.Contact,
	ObjectTypes.WorkOrder
];

export const VendorShareObjectTypes = [
	ObjectTypes.Bill,
	ObjectTypes.WorkOrder,
	ObjectTypes.Contact
];

export const MaintenanceTechnicianShareObjectTypes = [
	ObjectTypes.Bill,
	ObjectTypes.WorkOrder,
	ObjectTypes.Contact
];

export const allowOwnerShare = (objectTypeID, contactTypeID) => {
	if (objectTypeID == ObjectTypes.Contact) {
		return (contactTypeID == ContactTypes.Owner || contactTypeID == ContactTypes.Association);
	}

	return (OwnerShareObjectTypes.includes(objectTypeID));
}

export const allowTenantShare = (objectTypeID, contactTypeID) => {
	if (objectTypeID == ObjectTypes.Contact) {
		return (contactTypeID == ContactTypes.Tenant || contactTypeID == ContactTypes.Association);
	}

	return (TenantShareObjectTypes.includes(objectTypeID));
}

export const allowVendorShare = (objectTypeID, contactTypeID) => {
	if (objectTypeID == ObjectTypes.Contact) {
		return (contactTypeID == ContactTypes.Vendor);
	}

	return (VendorShareObjectTypes.includes(objectTypeID));
}

export const allowMaintenanceShare = (objectTypeID, contactTypeID) => {
	if (objectTypeID == ObjectTypes.Contact) {
		return (contactTypeID == ContactTypes.MaintenanceTechnician);
	}

	return (MaintenanceTechnicianShareObjectTypes.includes(objectTypeID));
}
